module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_1.6f4e5234.png";